import {createElement} from 'react'
import {renderToStaticMarkup} from 'react-dom/server'
import {IconType} from 'react-icons'

export const reactSvgComponent = (Component: IconType): string => `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(createElement(Component)))}`
